module.exports = __webpack_public_path__ + "static/media/wordmark_green.9b2b07b7.png";